import { render, staticRenderFns } from "./CapitalOrigin.vue?vue&type=template&id=1818306c&scoped=true"
import script from "./CapitalOrigin.vue?vue&type=script&lang=js"
export * from "./CapitalOrigin.vue?vue&type=script&lang=js"
import style0 from "./CapitalOrigin.vue?vue&type=style&index=0&id=1818306c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1818306c",
  null
  
)

export default component.exports